import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { productIcon } from '../helpers'
import React from 'react'

const ForecastEntry = props => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      container
      alignItems="center"
      className={props.classes.product}
      onClick={() => props.onSelectForecast(props.data)}>
      <Grid item xs={4} align="center">
        <img alt="" src={productIcon(props.data.productIconFileName)} className={props.classes.productIcon} />
      </Grid>
      <Grid item xs={7}>
        <Grid container direction="column">
          <Grid item>
            <Typography className={props.classes.productName}>{props.data.productType}</Typography>
          </Grid>
          <Grid item style={{ marginTop: -6 }}>
            <Typography className={props.classes.productTotalKg}>{props.data.totalKg} kg.</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={1}>
        <KeyboardArrowRightIcon />
      </Grid>
    </Grid>
  )
}

const styles = {
  product: {
    padding: '5px 0',
    borderRight: '1px solid #BBB',
    borderBottom: '1px solid #BBB',
    cursor: 'pointer',
  },
  productIcon: {
    width: '80%',
    maxWidth: 120,
  },
  productName: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B458E',
  },
  productTotalKg: {
    fontWeight: 'bold',
    fontSize: 30,
  },
  productNumDeliveries: {
    display: 'inline-block',
    background: '#8ACA4C',
    borderRadius: 5,
    color: 'white',
    padding: '2px 7px',
  },
}

export default withStyles(styles)(ForecastEntry)



// WEBPACK FOOTER //
// ./src/components/ForecastEntry.js